import envConfig from '../../static/config';
import ApiUtils from './ApiUtils';
import config from '../config';

const bioCatchCDNScriptId = 'bcCDN';

export function getCookieContent(name) {
  const content = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return content ? content[2] : '';
}

export function setBCCookie(name, value) {
  document.cookie = `${name}=${value}; path=/; secure`; // session cookie
}

export function deleteBCCookie(name) {
  document.cookie = `${name}=; expires=-1; path=/; secure`;
}

export function clearBCSID() {
  // Biocatch - delete related cookies
  deleteBCCookie('bcsid');
}

export function initBiocatch() {
  if (window.cdApi) {
    window.cdApi.setCustomerSessionId(getCookieContent('bcsid'));
  } else if (process.env.NODE_ENV === 'production') {
    setTimeout(() => initBiocatch(), 50);
  }
}

export function injectBCScriptTag() {
  if (!document.getElementById(bioCatchCDNScriptId)) {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'application/javascript';
    script.id = bioCatchCDNScriptId;
    head.appendChild(script);
    script.onload = initBiocatch();
    script.src = `${envConfig.biocatchScript}`;
  }
}

export function getBCScoreURL(bankId) {
  return `${envConfig.apiBaseUrlPAAS}/ibapi/v2/banks/${bankId}/analyticsCYBG/score`;
}

export function BCScoreApiCall({
  activityType,
  bankId,
  context,
  paymentDetails,
}) {
  const { fromAccountId, toAccountId, paymentAmount } = paymentDetails;
  const requestData = {
    biocatch_session_id: getCookieContent('bcsid'),
    biocatch_activity_type: activityType,
    biocatch_context: context,
    payer_account_id: fromAccountId,
    payee_id: toAccountId,
    // Backend expects prop that is a mix of camelCase & snake_case...
    ...(paymentAmount && { activity_Amount: paymentAmount.toFixed(2) }),
  };

  return ApiUtils.makeAjaxCall(
    {
      apiVersion: config.apiVersions.malwareServices,
      method: 'POST',
      url: getBCScoreURL(bankId.toUpperCase()),
      requestData,
      addAuthToken: true,
    },
    () => {},
    () => {}
  );
}
